module.exports = __webpack_public_path__ + "img/up2.d843dd5d.png";